function Troubleshooting() {
    return(
        <div>
            Troubleshooting
        </div>
    )
}

export default Troubleshooting;